/**
 * What this app is willing to put into a stylesheet.
 *
 * Colours are the one piece of user data that stops being text and becomes
 * **code the browser runs**: every one of them ends up in a `background` or a
 * `box-shadow`, and CSS values have side effects. `url(https://…)` is a valid
 * colour-position in several properties and issues a network request when it
 * paints — which would break the one promise this product makes without
 * qualification, that nothing leaves the device.
 *
 * React does not help here. It escapes text, but a style value is handed to the
 * CSSOM, which is happy to accept anything the parser recognises. The only
 * defence is refusing to store a value that is not a colour.
 *
 * Hex only, deliberately. The app's own colour input emits `#rrggbb` and the
 * chart palette is hex, so nothing legitimate is lost — and an allow-list of
 * one shape is a rule that cannot be argued with later. `rgb()`, `hsl()` and
 * the named colours would all be safe in themselves; the cost of admitting them
 * is a parser, and a parser is where the next hole goes.
 */

const HEX_COLOUR = /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i

export function isSafeColour(value: string): boolean {
  return HEX_COLOUR.test(value)
}
